import CssBaseline from '@mui/material/CssBaseline';
import {ThemeProvider} from '@mui/material/styles';
import {MessageProvider} from '@coolcolduk/ui-mui';
import AppRouter from './AppRouter';
import {theme} from './styles/theme';

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <MessageProvider>
        <AppRouter />
      </MessageProvider>
    </ThemeProvider>
  );
}
